import { MouseEventHandler } from 'react';
import { DataNodeModel, NodeKind } from '../../pages/editor/diagram/nodes/DataNodeModel';
import styles from './DiagramNodeTag.module.scss';

export interface DiagramNodeTagProps {
  node: DataNodeModel;
  active?: boolean;
  disabled?: boolean;
  onClick?: MouseEventHandler;
}

export const DiagramNodeTag = (props: DiagramNodeTagProps) => {

  const getLabel = () => {
    return props.node.kind !== NodeKind.NOTE ? props.node.getName() : 'Commentaire';
  }

  const CN_node = () => {
    const classes = [styles['node-item'], styles[props.node.kind]];
    if (props.active === undefined || props.active === true) {
      classes.push(styles['active']);
    }
    if (props.disabled !== undefined && props.disabled === true) {
      classes.push(styles['disabled']);
    }
    if (props.onClick !== undefined) {
      classes.push(styles['selectable']);
    }
    return classes.join(' ');
  }

  return (
    <div className={CN_node()} onClick={props.onClick}>
      <span className={styles['node-name']}>{getLabel()}</span>
      <span className={styles['node-id']}>{props.node.getID()}</span>
    </div>
  );
}
